import { getSize } from '@Hooks/useScreenSize';
import { Dimensions } from 'react-native';

import { ScreenSize } from '~types/views-types';

const { width } = Dimensions.get('screen');
const SCREEN_SIZE = getSize(width);

export const isMobile = [ScreenSize.mobile, ScreenSize.thinmobile].includes(
  SCREEN_SIZE
);
export const isTablet = [
  ScreenSize.tabletLandscape,
  ScreenSize.tabletPortrait,
].includes(SCREEN_SIZE);

export const IS_SMALL_SCREEN = isMobile || isTablet;

// Components sizes
const DRAWER_MAX_WIDTH = 672;
export const PRODUCT_CAROUSEL_WIDTH = 550;
export const PRODUCT_OPTIONS_MODAL_MIN_HEIGHT = 370;
export const CLOSE_ICON_SIZE = 27;

// For Margin
const DEFAULT_SCREEN_EDGE_DISTANCE = 20;
const SMALL_SCREEN_EDGE_DISTANCE = 10;
export const DISTANCE_FROM_EDGE = IS_SMALL_SCREEN
  ? SMALL_SCREEN_EDGE_DISTANCE
  : DEFAULT_SCREEN_EDGE_DISTANCE;

// Component sizes based on screen size
const DISPLAYABLE_MAX_WIDTH = (windowWidth: number) =>
  windowWidth - 2 * DISTANCE_FROM_EDGE;

export const PRODUCT_OPTIONS_MODAL_WIDTH = isMobile
  ? DISPLAYABLE_MAX_WIDTH
  : 446;

// Main Drawer Width
export const DRAWER_WIDTH = (windowWidth: number) =>
  Math.min(DISPLAYABLE_MAX_WIDTH(windowWidth), DRAWER_MAX_WIDTH);
